import { Design } from '@app/types';
import { useServices } from './use-services';
import { useAsync } from './useAsync';
import { useSubject } from './useSubject';

export function useLocalSerializedDesigns(): Design[] | null {
  const { lokiService } = useServices();
  const [initialValue] = useAsync(() => {
    return lokiService.getSerializedDesigns();
  }, [lokiService]);
  const updatedValue = useSubject(
    lokiService.serializedDesignsChange,
    null
  );

  return updatedValue ?? initialValue;
}
